if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector(
        '.js-results-container'
      );
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector(
        '.js-message-error'
      );
      this.errorMessageText =
        this.errorMessageContainer.querySelector('[data-text]');
      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest('.js-drawer');

      var searchDrawerContent = document.querySelector('.drawer__content--search');
      var searchSuggestions = document.querySelector('.search-drawer__suggestions');

      this.input.addEventListener('input', e => {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();

          if (searchTerm.length <= 0) {
            this.close();
            if(DeviceDetector.isMobile() || DeviceDetector.isTablet()) {
              searchDrawerContent.style.height = 'auto';
            }
            if(searchSuggestions) {
              searchSuggestions.style.display = 'block';
            }
            return;
          }

          this.isOpen = true;
          this.getSearchResults(searchTerm);
          if(DeviceDetector.isMobile() || DeviceDetector.isTablet()) {
            searchDrawerContent.style.height = '100%';
          }
          if(searchSuggestions) {
            searchSuggestions.style.display = 'none';
          }
        }, 300);
      });

      this.input.addEventListener('keydown', e => {
        const isEscape = e.key === 'Escape';

        if (!isEscape) {
          return;
        }

        if (!this.input.value) {
          if (this.drawer) {
            this.drawer.parentElement.parentElement.toggleDrawer();
          }

          return;
        }

        this.close();
      });

      this.btnClearText.addEventListener('click', e => {
        this.close();
        searchDrawerContent.style.height = 'auto';
        if(searchSuggestions) {
          searchSuggestions.style.display = 'block';
        }
      });
    }

    async getSearchResults(searchTerm) {
      try {
        const response = await fetch(
          `${Shopify.routes.root}search/suggest?q=${searchTerm}&resources[type]=product,page,article,collection,query&resources[limit]=10&resources[limit_scope]=each&section_id=predictive-search`
        );

        if (!this.isOpen) {
          return;
        }

        if (!response.ok) {
          const error = new Error(response.status);

          throw error;
        }

        const text = await response.text();
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector(
            '#shopify-section-predictive-search'
          ).innerHTML;

        this.resultsContainer.innerHTML = resultsMarkup;
        this.open();
        this.initProductArrows();

        // new added product cards - quick cart triggers - set event listeners
        document.querySelector('quick-cart-drawer')?.initTriggers();

      } catch (error) {
        this.errorMessageText.textContent = error.message;
        this.errorMessageContainer.classList.remove('hidden');
      }
    }

    initProductArrows() {
      const grid = this.resultsContainer.querySelector('.predictive-search__grid');
      const arrows = this.resultsContainer.querySelectorAll('.js-search-arrow');

      if (!grid || !arrows.length) {
        return;
      }

      // in RTL scrollLeft starts at 0 and goes negative, so flip the direction and use the absolute value
      const isRtl = getComputedStyle(grid).direction === 'rtl';

      // show arrows only when the row overflows, and disable the one at the end we're at
      const updateArrows = () => {
        const maxScroll = grid.scrollWidth - grid.clientWidth;
        const scrolled = Math.abs(grid.scrollLeft);

        const states = [...arrows].map(arrow => ({
          arrow,
          atEnd: arrow.dataset.direction === 'prev'
            ? scrolled <= 1
            : scrolled >= maxScroll - 1
        }));

        // enable before disable, so the opposite arrow can take focus below
        states.sort((a, b) => a.atEnd - b.atEnd).forEach(({ arrow, atEnd }) => {
          arrow.hidden = maxScroll <= 1;

          // a disabled button drops focus to <body> - hand it to the opposite arrow first
          if (atEnd && document.activeElement === arrow) {
            states.find(state => state.arrow !== arrow)?.arrow.focus();
          }

          arrow.disabled = atEnd;
        });
      };

      arrows.forEach(arrow => {
        arrow.addEventListener('click', () => {
          const card = grid.firstElementChild;
          const step = card
            ? card.offsetWidth + parseFloat(getComputedStyle(grid).columnGap || 0)
            : grid.clientWidth;

          const sign = (arrow.dataset.direction === 'prev' ? -1 : 1) * (isRtl ? -1 : 1);

          grid.scrollBy({
            left: sign * step,
            behavior: 'smooth'
          });
        });
      });

      grid.addEventListener('scroll', updateArrows, { passive: true });
      new ResizeObserver(updateArrows).observe(grid);
    }

    open() {
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.btnSubmit.setAttribute('tabindex', '-1');
      this.btnClearText.removeAttribute('disabled');
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.input.value = '';
      this.input.focus();
      this.btnSubmit.removeAttribute('tabindex');
      this.btnClearText.setAttribute('disabled', true);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}
